import { SitPosition } from './sit-position'

export interface PlayerGameResult {
  readonly userId: string
  readonly sitPosition: SitPosition
  readonly poolPoints: number
  readonly username: string
}

export const playerGameResultNull: PlayerGameResult = {
  userId: '',
  sitPosition: 'Center',
  poolPoints: 0,
  username: '',
}
